export class FacilitySearchRequest {
    baseScenarioId: number = -1;
    locId: string = '';
    region: string = '';
    state: string = '';
    hubSize: number = -1;
    level: number = -1;
    type: number = -1;
    allFaaTowers: boolean = false;
    allFaaContractTowers: boolean = false;
    oep35: boolean = false;
    centerId: number = -1;

    relieverFacility: number;
    relieverLocId: number;
    approachControlId: number;

    selectVariable: string;
    searchOption: string;
    growthStartYear: number;
    growthEndYear: number;
    growthOperator: string;
    growthPercentage: number;
    growthExcludeChanges: boolean;
    varValueYear: number;
    varValueOperator: string;
    varValue: number;
}


/** WEBPACK FOOTER **
 ** ./app/airports/facility-search-request.ts
 **/